export default "__VITE_ASSET__DjzlSa1Y__"